<div class="flex items-center">
  <button
    pButton
    type="button"
    (click)="menu.toggle($event)"
    text
    size="small"
    severity="secondary"
  >
    <fa-icon
      pButtonIcon
      [icon]="['fas', 'code-branch']"
      class="text-surface-400"
    ></fa-icon>
    <span
      pButtonLabel
      class="max-w-40 overflow-x-hidden whitespace-nowrap overflow-ellipsis"
      >{{ menuItems()[0].label }}</span
    >
    <i pButtonIcon class="{{ PrimeIcons.ANGLE_DOWN }}"></i>
  </button>
  <p-tiered-menu
    #menu
    [model]="menuItems()[0].items"
    [popup]="true"
    breakpoint="999999999"
  />
</div>
